import { Component, Input } from '@angular/core';
import { PLANNED_ACTIVITY_SIGN_OFF_PERIOD_STATUS } from 'src/app/work-and-rest-user/enums/planned-activity-sign-off-period-status.enum';

@Component({
  selector: 'app-work-and-rest-sign-off-template',
  templateUrl: './work-and-rest-sign-off-template.component.html',
  styleUrl: './work-and-rest-sign-off-template.component.scss',
  standalone: false,
})
export class WorkAndRestSignOffTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;

  PLANNED_ACTIVITY_SIGN_OFF_PERIOD_STATUS = PLANNED_ACTIVITY_SIGN_OFF_PERIOD_STATUS;
}
